import { useSelector } from 'react-redux';
import { getActiveLanguage } from '@client/i18n/redux/redux';
import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';

export const useActiveLanguage = (): LANGUAGE_CODE => useSelector(getActiveLanguage);
